import FetchHelpers from 'utils/FetchHelpers';
import { apiRoutes } from 'routes';

export default {
  requestProfileReview() {
    const url = apiRoutes.loanOfficerRequestApproveProfilePath();

    return FetchHelpers.post(url);
  },
  update(attrs) {
    const url = apiRoutes.authUpdateLoanOfficerPath();

    return FetchHelpers.post(url, attrs);
  },
  saveProfileVideo(attrs) {
    const url = apiRoutes.saveProfileVideoPath();

    return FetchHelpers.post(url, attrs);
  },
};



// WEBPACK FOOTER //
// ./src/repositories/loanOfficer/LoanOfficerSettingsRepository.js